/*
 * fn: compareText
 *
 * Compares two english text names for a sort()able response
 *
 */
const collator = new Intl.Collator('en')

export const compareText = (a: string, b: string) => collator.compare(a, b)
